import { Tooltip } from '@lifeomic/chroma-react/components/Tooltip';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.text.secondary,
    fontSize: theme.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold,
    marginRight: theme.spacing(0.625),
  },
}));

interface SequenceDetailsLabelProps {
  label: string;
  tooltipTitle: string;
}

export const SequenceDetailsLabel: React.FC<SequenceDetailsLabelProps> = ({
  label,
  tooltipTitle,
  ...rootProps
}) => {
  const classes = useStyles({});
  return (
    <span className={classes.root} {...rootProps}>
      <Tooltip title={tooltipTitle}>
        <span>{label}</span>
      </Tooltip>
    </span>
  );
};
